<div class="empty-table-box">
    <img src="assets/imgs/no-activity.png" alt="" width="105" />
    <div class="desc">{{description}}</div>
</div>
